<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { DxRadioGroup } from 'devextreme-vue/radio-group';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping, DxFilterRow,
  DxRemoteOperations, DxPager
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxFilterRow, DxToolbar, DxItem, DxRemoteOperations,
    DxRadioGroup, DxPager,
    Loader
  },
  data() {

    return {
      title: "Apuração CTE's",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Apuração CTE's",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,



      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      // tipoAgrupamentos: ['Estado', 'Cidade', 'Transportadora'],

      tipoAgrupamentos:  [
        { id: 'estado', text: 'Estado' },
        { id: 'cidade', text: 'Cidade' },
        { id: 'transportador', text: 'Transportador' },
        { id: 'transportadoruf', text: 'Transportador UF' },
      ],


      tipoAgrup: 'estado'



    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {


    mudouTipoAgrup(evt) {
      console.log('mudouTipoAgrup')
      console.log(evt.value)

      this.tipoAgrup = evt.value

      this.refeFormTable()
      this.atualizaDataList()
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      //this.title = `(${this.totalPages}) Apuração CTE's: ${dtIniFormated} - ${dtFimFormated}`
      this.title = `(${e.component.totalCount()}) Apuração CTE's: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.tipoAgrupamentos)

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const tpAgrup = this.tipoAgrup
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      let keyAgrup = ''
      switch (tpAgrup) {
        case 'estado':
          keyAgrup = 'estado'
          break

        case 'cidade':
          keyAgrup = 'cidade'
          break

        case 'transportador':
          keyAgrup = 'nome'
          break

        case 'transportadoruf':
          keyAgrup = 'nome'
          break
      }


      this.dataList = new CustomStore({
        key: keyAgrup,
        load: function(){

          console.log('tpAgrup')
          console.log(tpAgrup)

          // let queryArray = []

          const paramsReq = {
            'agrup': tpAgrup,
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movscteapr`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },




    abrirMovStatus(){
      console.log('abrirMovStatus')
      this.$router.push(`/movimentos/liststatus`)

    },


    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },



    novoCte(){
      console.log('novoCte')
      this.$router.push(`/movcte/importar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      // this.$router.push(`/movimento/editar/${idData}`)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = null
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {

        case 'EL':
          return 'Elaboração(EL)'

        case 'PR':              // desativado
          return 'Ordem Saída'  // desativado

        case 'OS':
          return 'Ordem Saída'

        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'

        case 'CCT':
          return 'Com CTe (CCT)'
          // case 'SCT':
          //   return 'Sem CTe'

          // case 'NEP':
          //   return 'Dentro do Prazo (Não Entregue)'
          // case 'NEF':
          //   return 'Fora do Prazo (Não Entregue)'

      }

      return e.value
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Novo CT-e"
              :on-click="novoCte"/>
        </DxItem>

        <DxItem
            location="after"
            widget="dxButton">

          <DxRadioGroup
              :items="tipoAgrupamentos"
              value-expr="id"
              display-expr="text"
              :value="tipoAgrup"
              @valueChanged="mudouTipoAgrup"
              layout="horizontal"

          />

        </DxItem>
      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">


        <DxRemoteOperations
            :filtering="false"
            :paging="false"
            :sorting="false"
            :summary="false"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>

        <DxFilterRow :visible="true" />



        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovCteListApuracao"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            v-if="tipoAgrup === 'estado'"
            data-field="estado"
            fixed-position="left"
            caption="Estado"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            v-if="tipoAgrup === 'cidade'"
            data-field="cidade"
            fixed-position="left"
            caption="Cidade"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            v-if="tipoAgrup === 'transportador' || tipoAgrup === 'transportadoruf'"
            data-field="nome"
            fixed-position="left"
            caption="Transportador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            v-if="tipoAgrup === 'transportador' || tipoAgrup === 'transportadoruf'"
            data-field="apirastreio"
            fixed-position="left"
            caption="API tracking"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            v-if="tipoAgrup !== 'transportador' && tipoAgrup !== 'estado'"
            data-field="uffim"
            fixed-position="left"
            caption="Estado"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn data-field="contagem"
                  caption="CTE's"
                  alignment="right"
                  data-type="number"
                  :format="formatInteger"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="valorcarga"
                  caption="Valor Carga"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="peso"
                  caption="Peso"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="valorfrete"
                  caption="Valor Frete"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="percentualFrete"
                  caption="Percentual Frete"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="saldofrete"
                  caption="Saldo Frete"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="conttransp"
                  caption="Qtd. Transp."
                  alignment="right"
                  data-type="number"
                  :format="formatInteger"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="fretekg"
                  caption="Frete Kg"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="valmedio"
                  caption="Valor Médio"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="valmedvenda"
                  caption="Valor Médio Venda"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="rastreadas"
                  caption="Notas Rastreadas"
                  alignment="right"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn data-field="nao_rastreadas"
                  caption="Notas Sem Rastreio"
                  alignment="right"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>
